import { co2 } from './common';

export default {
  'consumption.co2': `${co2} emisija kombinēti`,
  'consumption.energy': 'Strāvas patēriņš kombinētajā ciklā',
  'consumption.fuel': 'Kombinētais degvielas patēriņš',
  'footnotes.local': '',
  'footnotes.wltp':
    'Norādītās vērtības tika iegūtas saskaņā ar noteikto mērīšanas procedūru. Runa ir par “NEDC CO2 vērtībām” Komisijas Īstenošanas regulas (ES) 2017/1153 2. panta 3. punkta izpratnē. Strāvas patēriņš tika iegūts, pamatojoties uz Eiropas Parlamenta un Padomes Regulu (EK) Nr. 683/2008. Šie dati neattiecas uz konkrētu automobili un nav piedāvājuma sastāvdaļa, bet gan paredzēti tikai salīdzināšanai ar dažādiem automobiļu tipiem. Vērtības mainās atkarībā no izvēlētā speciālaprīkojuma.',
  'footnotes.nedc':
    'Norādītās vērtības tika iegūtas saskaņā ar noteikto mērīšanas procedūru. Runa ir par “NEDC CO2 vērtībām” Komisijas Īstenošanas regulas (ES) 2017/1153 2. panta 1. punkta izpratnē. Degvielas patēriņa vērtības tika aprēķinātas, pamatojoties uz šīm vērtībām. Šie dati neattiecas uz konkrētu automobili un nav piedāvājuma sastāvdaļa, bet gan paredzēti tikai salīdzināšanai ar dažādiem automobiļu tipiem. Vērtības mainās atkarībā no izvēlētā speciālaprīkojuma.',
  'footnotes.emissions.appendix':
    'Lai iegūtu vairāk informācijas par jaunu vieglo automobiļu oficiālo degvielas patēriņu un CO2 emisiju, lūdzu, sazinieties ar savu pilnvaroto Mercedes-Benz dīleri.',
  'search.input.label': 'Jūsu meklējums / OnlineCode konfigurators',
  'search.result.buy-online': 'Pirkt tiešsaistē',
  'search.results.count': '{count} meklēšanas rezultāti',
  'search.results':
    'Neatrada nevienu meklēšanas rezultātu | {count} meklēšanas rezultāts | {count} meklēšanas rezultāti',
  'search.results.backup': 'Neatrada nevienu precīzu atbilstību. Apskatiet radniecīgas lapas:',
  'search.results.none.summary':
    'Šim jēdzienam nav meklēšanas rezultātu. Lūdzu, pamēģiniet no jauna kādu citu meklējumu.',
  'search.show-more': 'Parādīt vairāk',
  'search.unavailable': 'Meklētājs pašlaik nav pieejams.',
  'search.result.new': 'Jauns',

  'input.placeholder': 'Jūsu meklējums / OnlineCode konfigurators',

  'suggestions.all_search_results': 'Visi meklēšanas rezultāti',
  'suggestions.all_search_results_for': 'Rādīt visus rezultātus',
  'suggestions.in': 'vietnē',

  all: 'Všechny',
  UCOS: 'Ojeté vozidlo | Internetový obchod',
  PASSENGER_CARS: 'Osobní vozidlo',
  VANS: 'Dodávková vozidla',
  NCOS: 'Nové vozidlo | Internetový obchod',
  VIDEO: 'Videa',
  DEALER_LOCATOR: 'Vyhledávání prodejců',
  CONFIGURATOR: 'Konfigurátor vozů Mercedes-Benz',
  TEST_DRIVE: 'Zkušební jízda',
  VEHICLE_SEARCH: 'Vyhledávání ojetých vozidel',
  COLLECT: 'Kolekce a příslušenství',
  CONNECT: 'Mercedes me Store',

  'search.result.consumption': 'Patēriņš',
  'watch.video': 'Skatīties video',
  'input.recently': 'Nesen meklēts',
  'input.help.title': 'Kas būtu jāmeklē?',
  'input.help.text':
    'Meklēt, izmantojot automobiļu tipus, modeļus, konfigurācijas kodus vai piederumus, citus produktus un informāciju',

  'search.result.grid': 'Galerija',
  'search.result.list': 'Saraksts',
};
